/* eslint-disable global-require */
import './assets/css/vendor/bootstrap.min.css';
import './assets/css/vendor/bootstrap.rtl.only.min.css';
import 'react-circular-progressbar/dist/styles.css';
import 'react-perfect-scrollbar/dist/css/styles.css';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import 'react-image-lightbox/style.css';
import 'video.js/dist/video-js.css';
import { getCurrentColor, setCurrentColor, getThemeMode, resolveThemeColor } from './helpers/Utils';

const mode = getThemeMode();
const color = resolveThemeColor(mode);
setCurrentColor(color);

const render = () => {
  import(`./assets/css/sass/themes/gogo.${color}.scss`).then(() => {
    require('./AppRenderer');
  });
};
render();

// When in Auto mode, reload on system theme change
if (mode === 'auto') {
  window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', () => {
    window.location.reload();
  });
}
